import styled from 'styled-components';

export const PromoContainer = styled.div`
  width: 270px;
  padding-right: 28px;
  pointer-events: all;
  text-align: left;
`;
